/**
 * Extract Option C details from AI recommendation text
 * @param {string} recommendation - The AI recommendation text
 * @returns {Object|null} - Option C details or null if not detected
 */
export const parseOptionC = (recommendation) => {
  if (!recommendation || (!recommendation.includes('💡') && !recommendation.includes('OPTION C:'))) {
    return null;
  }

  try {
    // Extract Option C name (remove any markdown formatting)
    const nameMatch = recommendation.match(/OPTION C:\s*([^\n]+)/);
    if (!nameMatch) return null;

    let name = nameMatch[1].trim();
    // Remove markdown bold markers if present
    name = name.replace(/\*\*/g, '').trim();

    // Extract type (AND/WAIT/alternative)
    const typeMatch = recommendation.match(/This is a.*?\*\*([A-Z]+[^*]*)\*\*/);
    const type = typeMatch ? typeMatch[1].trim() : 'WAIT';

    // Extract description (first sentence after "What it is:")
    const descMatch = recommendation.match(/What it is:\s*([^\n]+(?:\n[^\n]+)?)/);
    const description = descMatch ? descMatch[1].trim() : name;

    // Create a short button label (max 3 words)
    let buttonLabel = name;
    const words = name.split(' ');
    if (words.length > 3) {
      buttonLabel = words.slice(0, 3).join(' ');
    }

    return {
      name,
      type,
      description,
      buttonLabel
    };
  } catch (error) {
    console.error('Error parsing Option C:', error);
    return null;
  }
};
